import React from 'react'

export default (props) => {

    const handleChange = () =>{
        props.setMount(false);
        props.setLoad(true);
        props.setCurrentPage(1);

        switch (props.type) {

            case 'Profile': {

                if (props.name === 'Denunciantes') {
                    props.setB1(true);
                    props.setB2(false);
                    props.setB3(false);
                }else if (props.name === 'Denunciados') {
                    props.setB1(false);
                    props.setB2(true);
                    props.setB3(false);
                }else if (props.name === 'Ouvidorias') {
                    props.setB1(false);
                    props.setB2(false);
                    props.setB3(true);
                }else {
                    props.setB1(false);
                    props.setB2(false);
                    props.setB3(false);
                }
                break;
            }

            case 'Denunce': {
                
                if (props.name === 'Maximo') {
                    props.setviewMaximo(true);
                    props.setviewMuitoGrave(false); 
                    props.setviewGrave(false);
                    props.setviewModerado(false);
                    props.setviewLeve(false);
                    props.setviewTodos(false);
                }else if (props.name === 'Muito Grave') {
                    props.setviewMaximo(false);
                    props.setviewMuitoGrave(true); 
                    props.setviewGrave(false);
                    props.setviewModerado(false);
                    props.setviewLeve(false);
                    props.setviewTodos(false);
                }else if (props.name === 'Grave') {
                    props.setviewMaximo(false);
                    props.setviewMuitoGrave(false); 
                    props.setviewGrave(true);
                    props.setviewModerado(false);
                    props.setviewLeve(false);
                    props.setviewTodos(false);
                }else if (props.name === 'Moderado') {
                    props.setviewMaximo(false);
                    props.setviewMuitoGrave(false); 
                    props.setviewGrave(false);
                    props.setviewModerado(true);
                    props.setviewLeve(false);
                    props.setviewTodos(false);
                }else if (props.name === 'Leve') {
                    props.setviewMaximo(false);
                    props.setviewMuitoGrave(false); 
                    props.setviewGrave(false);
                    props.setviewModerado(false);
                    props.setviewLeve(true);
                    props.setviewTodos(false);
                }else if (props.name === 'Todas') {
                    props.setviewMaximo(false);
                    props.setviewMuitoGrave(false); 
                    props.setviewGrave(false);
                    props.setviewModerado(false);
                    props.setviewLeve(false);
                    props.setviewTodos(true);
                }else {
                    props.setviewMaximo(false);
                    props.setviewMuitoGrave(false); 
                    props.setviewGrave(false);
                    props.setviewModerado(false);
                    props.setviewLeve(false);
                    props.setviewTodos(false);  
                }
                break;
            }

            default: {
                throw new Error('Button must have a type');
            }
        }
        
        props.setDisabled(true);
    }

    return(
        <button 
            className={!props.white ? 'filter-buttons-white' : 'filter-buttons'} 
            onClick={handleChange} 
            disabled={props.disable}
        > 
            <p className={!props.white ? 'filter-button-text-purple' : 'filter-button-text'}>{props.name}</p>
        </button>
    )
}